export enum ActionText {
  Next = "Next",
  Finish = "Finish",
}
